<template>
  <mw-dialog ref="dialog" :appendToBody="false" title="办理过程" size='large_large' customClass='mw-form-view-dialog'>
    <div class="mw-margin-top-10 process-dialog" >
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="流程办理过程" name="first">
          <mw-table :api="api" :columns="columns" :pagination="false"
                    :nowrap="false" :defaultParams="defaultParams" :defaultParamsAutoLoad="true" ></mw-table>
        </el-tab-pane>
        <el-tab-pane label="阅知办理过程" name="second">
          <template v-if="showSecond">
                      <mw-table :api="apiSecond"  :columns="columnsSecond"  :pagination="false"
                                :nowrap="false" :defaultParams="defaultParamsSecond" :defaultParamsAutoLoad="true" ref="circularTable"></mw-table>
                    </template>
        </el-tab-pane>
      </el-tabs>
    </div>
  </mw-dialog>
</template>
<script>

export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    let me = this;
    return {
      activeName: 'first',
      showSecond: false,
      api:'process.getFlowProcess',
      defaultParams:{batchId:this.params.batchId,type:1},
      columns: [
        {type: 'index',width: '40'},
        {prop: 'name',tooltip:true, label: '任务名称',width: '80'},
        {prop: 'sender',tooltip:true, label: '发送人',width: '80'},
        {prop: 'createTime', label: '发送时间',width: '118',formatter:me.dateFormatter},
        {prop: 'department',tooltip:true, label: '办理部门',width:'100'},
        {prop: 'assigneeName',tooltip:true, label: '办理人',width:'100'},
        {prop: 'claimTime',label: '签收时间',width: '118',formatter:me.dateFormatter},
        {prop: 'finishTime',label: '完成时间',width: '118',formatter:me.dateFormatter},
        {prop: 'status',tooltip:true,label:'状态',width:'80',formatter:me.statusFormatter},
        {prop: 'comment',label:'意见'}
      ],

      apiSecond:'process.getFlowProcess',
      defaultParamsSecond:{batchId:this.params.batchId,type:0},
      columnsSecond: [
        {type: 'index',width: '40'},
        {prop: 'name',tooltip:true, label: '任务名称',width: '80'},
        {prop: 'sender',tooltip:true, label: '发送人',width: '80'},
        {prop: 'createTime', label: '发送时间',width: '118',formatter:me.dateFormatter},
        {prop: 'department',tooltip:true, label: '办理部门',width:'100'},
        {prop: 'assigneeName',tooltip:true, label: '办理人',width:'80'},
        {prop: 'claimTime',label: '签收时间',width: '118',formatter:me.dateFormatter},
        {prop: 'finishTime',label: '完成时间',width: '118',formatter:me.dateFormatter},
        {prop: 'status',tooltip:true,label:'状态',width:'80',formatter:me.statusFormatter},
        {prop: 'comment',label:'意见'},
        {label:'操作', width:'40',formatter:me.operatorFormatter}
      ]
    };
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
  },
  watch: {
    params(val) {
      this.showSecond=false;
      this.activeName='first';
      this.defaultParams={batchId:val.batchId,type:1};
      this.defaultParamsSecond={batchId:val.batchId,type:0};
    },
  },
  methods: {
    operatorFormatter(row){
        let me=this;
        if(me.params.taskId){
          if(row.currentUserId==row.senderId && !row.claimTime && !row.finishTime){
            return (<span>
              <span class={{'link':true}}  onClick={(event)=>me._deleteTask(row, event)}>
            取回
            </span>
            </span>)
          }
        }
        return "";
      },
     statusFormatter(row, col, cellValue){
        if(cellValue){
          if(row.finishTime){
            return '<'+cellValue+'>';
          }
        }
         return cellValue;
     },
      dateFormatter(row, col, cellValue){
          if(cellValue){
            return cellValue.substring(2,cellValue.lastIndexOf(':'));
          }
          return '';
      },
      _deleteTask(row, event){
        event.stopPropagation();
        let me = this;
        me.mwApi.process.deleteCircularTask({taskId:me.params.taskId, deletedTaskId:row.id}).then(res =>{
          if(res.success){
              me.mwRef('circularTable').refresh();
          }
        });
      },
    handleClick(tab, event) {
      if(tab.name=='second' && !this.showSecond){
        this.showSecond=true;
      }
    },

    show(){
        this.mwRef('dialog').show();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/transaction-process.vue